import { Person } from "./person.model";

export class Department {
  _id?: string;
  name: string = "";
  persons: Array<Person> = [];
  active: boolean = false;
  requestProduct: boolean = false;
  created: Date;
  updated: Date;
}



// WEBPACK FOOTER //
// ./libs/atenea-cms-brand/src/departments/shared/department.model.ts